import { graphql } from '@data-access/graphql'
import type { ResultOf } from '@graphql-typed-document-node/core'

export const GuestDataDocument = graphql(`
  query guestData {
    guestData {
      firstName
      lastName
      email
    }
  }
`)

export type GuestDataQuery = ResultOf<typeof GuestDataDocument>
